<div class="cosmos-accordion">
  <mat-accordion>
    <mat-expansion-panel
      [expanded]="true"
      (opened)="areDetailsOpened = true"
      (closed)="areDetailsOpened = false"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ panelTitle }}
        </mat-panel-title>
        <mat-panel-description>
          {{ areDetailsOpened ? 'Hide' : 'Show'}}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div [ngClass]="numberOfColumns === 3 ? 'cosmos-accordion__wrapper-3col' : 'cosmos-accordion__wrapper-2col'">
        <div
          *ngFor="let item of accordionItems"
          [ngClass]="{'cosmos-accordion__image': item?.isImage}"
          class="w-100"
        >
          <ng-container
            *ngIf="item.template"
            [ngTemplateOutlet]="item.template"
          ></ng-container>
          <ng-container *ngIf="!item.template">
            <span class="cosmos-accordion__label">
              {{ item.name }}
              <span class="cosmos-accordion__label__data">
                {{ item.value }}
              </span>
            </span>
          </ng-container>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
